import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from '../config/axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { extractEmails, extractPhoneNumber, phoneFormat, validRegex } from "../helper/helper";

export const postChat = createAsyncThunk("postChatData", async (arg, { rejectWithValue }) => {
    // console.log(arg);
    try {
        const { data } = await axios.post('/playgroundController/doChat', arg, {
            // signal: AbortSignal.timeout(5000)
        });
        return data;
    } catch (error) {
        rejectWithValue(error);
    }
})

const initialState = {
    loading: false,
    chat: [
        {
            'question' : 'Welcome to this demo conversation. Write anything or ask a question that relates to the context you provided above.',
            'answer' : ''
        },
        
    ],
    chatInput: '',
    chatStatus: false,
    trafficSource: 'Zyratalk',
    trafficMedium: 'Organic',
    leadPhoneNumber: '',
    leadEmail: '',
    leadZipcode: '',
    sendLead: 'No',
    leadTranscript: 'Send full transcript'
}

export const playgroundDemoSlice = createSlice({
    name: 'demoChat',
    initialState,
    reducers: {
        onInputChat : (state, {payload}) => {
            state.chatInput = payload;
        },
        onDoChat: (state, {payload}) => {
            const chatData = JSON.parse(JSON.stringify(state.chat));
            if (chatData[chatData.length - 1].answer != '' && typeof chatData[chatData.length - 1].answer === 'object') {
                chatData[chatData.length - 1].answer.push(state.chatInput);
            }else if(chatData[chatData.length - 1].answer != '' && typeof chatData[chatData.length - 1].answer === 'string'){
                let news = [chatData[chatData.length - 1].answer, state.chatInput];
                chatData[chatData.length - 1].answer = news
            }else{
                chatData[chatData.length - 1].answer = state.chatInput;
            }
            if(state.chatInput){
                const extractEmailsfrommsg = extractEmails(state.chatInput);
                state.leadEmail = extractEmailsfrommsg ? extractEmailsfrommsg : state.leadEmail;
                const extractPhonefrommsg = extractPhoneNumber(state.chatInput);
                state.leadPhoneNumber = extractPhonefrommsg ? extractPhonefrommsg : state.leadPhoneNumber;
                let checkzipcode = state.chatInput.match(/\b\d{5}\b/g);
                if(checkzipcode && checkzipcode.length){
                    state.leadZipcode = checkzipcode[0];
                }
            }
            state.chat = chatData
            state.chatInput = '';
            state.loading = true;
            state.chatStatus = true;
        },
        onResetChat : (state, {payload}) => {
            state.chat = [
                {
                    'question' : 'Welcome to this demo conversation. Write anything or ask a question that relates to the context you provided above.',
                    'answer' : ''
                },
                
            ];
            state.leadEmail = '';
            state.leadPhoneNumber = '';
            state.leadZipcode = '';
            state.chatInput = '';
            state.chatStatus = false;
            state.loading = false;
        }
    },
    extraReducers: {
        [postChat.pending]: (state, { payload }) => {
            state.chatStatus = false;
        },
        [postChat.fulfilled]: (state, { payload }) => {
            // console.log("pyaload", payload);
            state.loading = false;
            const chatData = JSON.parse(JSON.stringify(state.chat));
            if(payload.status){
                chatData.push({
                    'question' : payload.text,
                    'answer': ''
                });
                state.chat = chatData
            }
        },
        [postChat.rejected]: (state, { payload }) => {
            // state.message = payload;
            state.loading = false;
            // state.isSuccess = false;
        },
    }
});

export const {onInputChat, onDoChat, onResetChat} = playgroundDemoSlice.actions;
export default playgroundDemoSlice.reducer;